import Vue from "vue";
import Vuex from "vuex";
import { isMobile } from "@/utils/index.js";
// import getters from "./getters";
Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		userData: sessionStorage.getItem('userData') ? sessionStorage.getItem('userData') : localStorage.getItem('userData'),
		isCollapse:isMobile(),//侧边栏折叠
		isMsgAlert:false,//消息提示
		isSmsLogin:false,//短信验证码登录]
		isDomainAllowedFlag:true,//是否允许域名
		isDomainAllowedNum:0,//域名进入次数，第一次拦截，第二次不拦截
		// userData:sessionStorage.getItem('userData')
	},
	getters: {
		isCollapse: state =>state.isCollapse,
		isMsgAlert: state =>state.isMsgAlert,
		isSmsLogin:state => state.isSmsLogin,
		isDomainAllowedFlag:state => state.isDomainAllowedFlag,
	},
	mutations: {
		SET_ISSMSLOGIN: (state, isSmsLogin) => {  //设置用户每次登陆时是否显示短信验证码弹框
			state.isSmsLogin = isSmsLogin;
		  },
		SET_MSGAlERT: (state, isMsgAlert) => {  //设置用户每次登陆时是否显示消息提示弹框
			state.isMsgAlert = isMsgAlert;
		  },
		SET_COLLAPSE: (state, isCollapse) => {  //设置侧边栏折叠
			state.isCollapse = isCollapse;
		  },
		SET_ISDOMAINALLOWEDFLAG: (state, isDomainAllowedFlag) => {  //设置是否允许域名
			state.isDomainAllowedFlag = isDomainAllowedFlag;
		  },
		SET_ISDOMAINALLOWEDNUM: (state, isDomainAllowedNum) => {  //设置域名进入次数，第一次拦截，第二次不拦截
			state.isDomainAllowedNum = isDomainAllowedNum;
		  },
		setUserData: (state, userData) => {
			state.userData = userData;
			localStorage.setItem('userData', JSON.stringify(userData));
			console.log("state.userData ");
		},
	},
	state1: {
		LOADING: false
	},
	mutations2: {
		showLoading(state) {
			state.LOADING = true
		},
		hideLoading(state) {
			state.LOADING = false
		}
	}

});
